import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { constants, mixpanel, snowplow } from 'common/helpers'

import Message from 'components/text/Message/Message'
import SrcSize from 'components/ui/SrcSize/SrcSize'
import { AddToQueueButton } from 'components/_new/buttons/addTo'
import ContentWithLoader from 'components/loaders/ContentWithLoader/ContentWithLoader'
import { MenuLink } from 'components/_new/ui/Menu'

import s from './Product.scss'


class HeaderSubNavDropdownProduct extends PureComponent {

  static propTypes = {
    className: PropTypes.string,
    titleProps: PropTypes.shape({
      title: PropTypes.object.isRequired,
      to: PropTypes.string,
      onClick: PropTypes.func,
    }).isRequired,
    product: PropTypes.shape({
      id: PropTypes.number,
      brand: PropTypes.string,
      name: PropTypes.string,
      url: PropTypes.string,
    }),
    hideBrand: PropTypes.bool,
    subtitle: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.string,
    ]),
    addButtonProps: PropTypes.shape({
      metadata: PropTypes.object,
      snowplowMetadata: PropTypes.object,
    }).isRequired,
    placement: PropTypes.string.isRequired,
    isFetching: PropTypes.bool,
  }

  handleTitleClick = (event) => {
    const { titleProps: { onClick } } = this.props

    if (typeof onClick === 'function') {
      onClick(event)
    }
  }

  handleProductClick = () => {
    const { placement, product } = this.props

    snowplow.track(constants.snowplowEvents.navigationMenuClick, {
      link: product.url,
      title: `${product.brand} ${product.name}`,
    })
  }

  render() {
    const {
      className, titleProps, product, isFetching, hideBrand, subtitle,
      addButtonProps: { metadata, snowplowMetadata },
      titleAdaIndex, adaIndex, _ref, state, setState,
    } = this.props

    let title = null

    if (Boolean(titleProps.to)) {
      title = (
        <MenuLink
          className={cx(s.title, s.titleLink)}
          title={titleProps.title}
          to={titleProps.to}
          index={titleAdaIndex}
          customColor
          onClick={this.handleTitleClick}
          _ref={_ref(titleAdaIndex)}
          {...{ state, setState }}
        />
      )
    }
    else if (Boolean(product)) {
      title = (
        <MenuLink
          className={cx(s.title, s.titleLink)}
          title={titleProps.title}
          to={product.url}
          index={titleAdaIndex}
          customColor
          onClick={this.handleProductClick}
          _ref={_ref(titleAdaIndex)}
          {...{ state, setState }}
        />
      )
    }
    else {
      title = (
        <Message tag="div" className={s.title} text={titleProps.title} />
      )
    }

    return (
      <div className={cx(s.root, className)}>
        {title}
        <div className={s.container}>
          <ContentWithLoader isFetching={isFetching}>
            {
              Boolean(product) && (
                <MenuLink
                  className={s.product}
                  to={product.url}
                  index={adaIndex}
                  customColor
                  onClick={this.handleProductClick}
                  _ref={_ref(adaIndex)}
                  {...{ state, setState }}
                >
                  <div className={s.imageContainer}>
                    <SrcSize src={product.img} w={200}>
                      {(src) => (
                        <div className={s.image} style={{ backgroundImage: `url(${src})` }} />
                      )}
                    </SrcSize>
                    <AddToQueueButton
                      noSize
                      className={s.queueButton}
                      product={product}
                      metadata={metadata}
                      snowplowMetadata={snowplowMetadata}
                      dataTestId={constants.testIds.addTo.queue}
                      title={null}
                      lg={false}
                    >
                      <svg viewBox="0 0 26 26" width={26} height={26}>
                        <circle fill="currentColor" cx="13" cy="13" r="13" />
                        <path d="M12 14H7v-2h5V7h2v5h5v2h-5v5h-2v-5z" fill="#FFF" />
                      </svg>
                    </AddToQueueButton>
                  </div>
                  <div className={s.productTitle}>
                    {!hideBrand && `${product.brand} `}
                    {product.name}
                  </div>
                  {Boolean(subtitle) && (
                    <Message text={subtitle} tag="div" className={s.productSubtitle} />
                  )}
                </MenuLink>
              )
            }
          </ContentWithLoader>
        </div>
      </div>
    )
  }
}

export default HeaderSubNavDropdownProduct
